export default __webpack_public_path__ + "static/media/Db_3.fbe2ae80.png";